import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { OrderHistoryEvent } from 'entities/orderHistory/model/types'
import { OrderHistoryApi } from '../../api'
import { QueryKeys } from './constants'

export const useOrderHistoryQuery = (
    orderId: number | null,
    options?: UseQueryOptions,
) => {
    const { data, error, isError, isLoading, isSuccess, refetch, status } =
        useQuery({
            initialData: [],
            queryKey: [QueryKeys.GetAllOrderHistoryItems, orderId],
            queryFn: orderId
                ? () => OrderHistoryApi.getOrderHistory(orderId)
                : () => {},
            ...(options ?? {}),
            enabled: !!orderId,
        })

    return {
        orderHistory: data as OrderHistoryEvent[],
        error,
        status,
        refetch,
        isSuccess,
        isLoading,
        isError,
    }
}
